import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CustomPage } from "src/app/models/custom-page-model";
import { DefaultService } from "src/app/services/default/default.service";
import { StudioService } from "src/app/services/studio/studio.service";
import { GenerateErrors } from "src/app/utils/generate-errors";
import Swal from "sweetalert2";
import { Location } from "@angular/common";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";
import { StripeService } from "src/app/services/stripe/stripe.service";

@Component({
  selector: "app-studios",
  templateUrl: "./studios.component.html",
  styleUrls: ["./studios.component.scss"],
})
export class StudiosComponent implements OnInit {
  sub_title: string = "";

  show_add_button: boolean = false;
  show_delete_button: boolean = false;
  custom_page: CustomPage;

  index: string = "id";
  custom_buttons: Array<any> = [
    {
      text: '<i class="fa fa-question"></i> comment ça marche',
      class: "btn btn-xl btn-dark",
      action: () => {
        Webflow.myAction(this.router, "payment-help", {});
      },
    },
    {
      text: "Ajouter",
      class: "btn btn-xl btn-studiomap",
      action: () => {
        this.stripeService.check_payouts_enabled().subscribe(
          (res) => {
            if (res.payouts_enabled == true) {
              Webflow.myAction(this.router, "studios/ajouter", {});
            } else {
              Webflow.setIFrameHeight();
              Swal.fire({
                title: "Vérification",
                text: "Votre compte doit êtres vérifié",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: `Mon profil`,
                cancelButtonText: `Annuler`,
                cancelButtonColor: "black",
                confirmButtonColor: "#D63333",
                position: "top",
              }).then((result) => {
                if (result.isConfirmed) {
                  Webflow.myAction(this.router, "user-profile", {});
                }
              });
            }
          },
          (error) => {
            Webflow.setIFrameHeight();
            if (GenerateErrors.check_if_is_custom_error(error)) {
              Swal.fire({
                title: "Erreur",
                text: GenerateErrors.get_message_error(error),
                icon: "error",
                position: "top",
              });
            } else {
              Swal.fire({
                title: "Erreur",
                text: "une erreur s'est produite",
                icon: "error",
                position: "top",
              });
            }
          }
        );
      },
    },
    {
      text: '<i class="fa fa-sync"></i> Actualiser',
      class: "btn btn-xl btn-outline-studiomap",
      action: () => {
        Webflow.myAction(this.router, "studios", {});
      },
    },

  ];

  columns: Array<any> = [
    /*
    {
      key: "thumbnail",
      type: "image",
      class: "",
      value: "",
      concat_value: "",
      field_relation: "",
    },
    */
    {
      keys: [
        {
          key: "private_name",
          field_relation: "",
          class: "font-weight-bold",
        },
        {
          key: "email",
          field_relation: "",
          class: "",
        },
        {
          key: "phone",
          field_relation: "",
          class: "",
          concat_field_before: "country_code_phone",
          concat_field_after: "",
        },
      ],
      type: "card",
      value: "Studio",
    },
    {
      key: "type_name",
      type: "enum",
      class: {
        ENREGISTREMENT: "badge badge-primary",
        PHOTOGRAPHIE: "badge badge-primary",
        DJ: "badge badge-primary",
        PODCAST: "badge badge-primary",
      },
      text: {
        ENREGISTREMENT: "ENREGISTREMENT",
        PHOTOGRAPHIE: "PHOTOGRAPHIE",
        DJ: "DJ",
        PODCAST: "PODCAST",
      },
      value: "Type",
      concat_value: "",
      field_relation: "",
      list: [
        { value: "ENREGISTREMENT", text: "ENREGISTREMENT" },
        { value: "PHOTOGRAPHIE", text: "PHOTOGRAPHIE" },
        { value: "DJ", text: "DJ" },
        { value: "PODCAST", text: "PODCAST" },
      ],
    },
    {
      key: "count_booking",
      type: "text",
      class: "font-weight-bold",
      value: "Nbr réservation",
      concat_value: "",
      field_relation: "",
    },
    {
      key: "ical_link",
      type: "check",
      value: "Ical",
      operation: "empty",
      yes: '<i class="ni ni-fat-remove text-danger fa-lg"></i>',
      no: '<i class="fa fa-check text-success"></i>',
    },
    {
      key: "webflow_sync",
      type: "check",
      value: "synchronisation",
      operation: "boolean",
      yes: '<i class="fa fa-check text-success"></i>',
      no: '<i class="fas fa-sync text-danger"></i>',
    },
    {
      key: "createdAt",
      type: "date",
      class: "badge badge-info font-weight-bold",
      value: "Date de création",
      concat_value: "",
      field_relation: "",
      order_by: true,
      order_by_option: "desc",
    },
  ];

  multi_actions: Array<any> = [];

  visible_actions: Array<any> = [
    /*
    {
      title: "Supprimer le studio",
      icon: "fa fa-trash",
      class: "text-danger",
      onClick: (value: any) => {
        Webflow.setIFrameHeight();
        Swal.fire({
          title: "Suppression",
          text: "Étes-vous sûre de vouloir supprimer ce studio ?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: `Confirmer`,
          cancelButtonText: `Annuler`,
          cancelButtonColor: "black",
          confirmButtonColor: "#D63333",
          position: "top",
        }).then((result) => {
          if (result.isConfirmed) {
            this.spinner.show();
            this.studioService
              .custom_delete(value.id)
              .subscribe(
                (res) => {
                  Swal.fire({
                    title: "Félicitation",
                    text: "Studio supprimé avec succés",
                    icon: "success",
                    position: "top",
                  });

                  this.activatedRoute.queryParams.subscribe((params) => {
                    this.redirectTo(this.router.url.split("?")[0], params);
                  });
                },
                (error) => {
                  if (GenerateErrors.check_if_is_custom_error(error)) {
                    Swal.fire({
                      title: "Erreur",
                      text: GenerateErrors.get_message_error(error),
                      icon: "error",
                      position: "top",
                    });
                  } else {
                    Swal.fire({
                      title: "Erreur",
                      text: "Erreur de connexion",
                      icon: "error",
                      position: "top",
                    });
                  }
                }
              )
              .add(() => {
                this.spinner.hide();
              });
          }
        });
      },
    }
    */
  ];

  invisible_actions: Array<any> = [];

  constructor(
    private defaultService: DefaultService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private studioService: StudioService,
    private stripeService: StripeService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      let filters = "";
      filters +=
        params.manager != undefined &&
        params.manager != "" &&
        params.manager != null
          ? "&filters[manager][id]=" + params.manager
          : "";

      this.sub_title =
        params.manager_email != undefined &&
        params.manager_email != "" &&
        params.manager_email != null
          ? "GERANT : " + params.manager_email
          : "";

      this.custom_page = new CustomPage("studios", "", "studios", "", filters);
    });
  }

  redirectTo(uri: string, params: any) {
    this.router
      .navigateByUrl("/", { skipLocationChange: false })
      .then(() => this.router.navigate([uri], { queryParams: params }));
  }
}
